const _excluded = ["preset"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
// Preset
import { preset as Preset } from '../../presets/default'; // Utilities

import { consoleWarn } from '../../util/console';
import { mergeDeep } from '../../util/helpers';
import { Service } from '../service';
export class Presets extends Service {
  constructor(parentPreset, parent) {
    super(); // The default preset

    const defaultPreset = mergeDeep({}, Preset); // The user provided preset

    const userPreset = parent.userPreset; // The user provided global preset

    const _userPreset$preset = userPreset.preset,
      globalPreset = _userPreset$preset === void 0 ? {} : _userPreset$preset,
      preset = _objectWithoutProperties(userPreset, _excluded);
    if (globalPreset.preset != null) {
      consoleWarn('Global presets do not support the **preset** option, it can be safely omitted');
    }
    parent.preset = mergeDeep(mergeDeep(defaultPreset, globalPreset), preset);
  }
}
Presets.property = 'presets';